<template>
  <div>
    <h2 style="font-family:&quot;font-weight:500;color:#333333;font-size:30px;">
      隐私政策
    </h2>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      本应用尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。 您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本应用服务使用协议不可分割的一部分。
    </p>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      1. 适用范围<br />
      a) 在您注册本应用帐号时，您根据本应用要求提供的个人注册信息；<br />
      b) 在您使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；<br />
      c) 本应用通过合法途径从商业伙伴处取得的用户个人数据。
    </p>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      您了解并同意，以下信息不适用本隐私权政策：<br />
      a) 您在使用本应用平台提供的搜索服务时输入的关键字信息；<br />
      b) 本应用收集到的您在本应用发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；<br />
      c) 违反法律规定或违反本应用规则行为及本应用已对您采取的措施。
    </p>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      2. 信息使用<br />
      a) 本应用不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和本应用（含本应用关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。<br />
      b) 本应用亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何本应用平台用户如从事上述活动，一经发现，本应用有权立即终止与该用户的服务协议。<br />
      c) 为服务用户的目的，本应用可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与本应用合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）。
    </p>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      3. 信息披露<br />
      在如下情况下，本应用将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：<br />
      a) 经您事先同意，向第三方披露；<br />
      b) 为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；<br />
      c) 根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；<br />
      d) 如您出现违反中国有关法律、法规或者本应用服务协议或相关规则的情况，需要向第三方披露；<br />
      e) 如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；<br />
      f) 在本应用平台上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，本应用有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成或纠纷的解决。<br />
      g) 其它本应用根据法律、法规或者网站政策认为合适的披露。
    </p>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      4. 信息存储和交换<br />
      本应用收集的有关您的信息和资料将保存在本应用及（或）其关联公司的服务器上，这些信息和资料可能传送至您所在国家、地区或本应用收集信息和资料所在地的境外并在境外被访问、存储和展示。
    </p>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      5. Cookie的使用<br />
      a) 在您未拒绝接受cookies的情况下，本应用会在您的计算机上设定或取用cookies ，以便您能登录或使用依赖于cookies的本应用平台服务或功能。本应用使用cookies可为您提供更加周到的个性化服务，包括推广服务。<br />
      b) 您有权选择接受或拒绝接受cookies。您可以通过修改浏览器设置的方式拒绝接受cookies。但如果您选择拒绝接受cookies，则您可能无法登录或使用依赖于cookies的本应用网络服务或功能。<br />
      c) 通过本应用所设cookies所取得的有关信息，将适用本政策。
    </p>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      6. 信息安全<br />
      a) 本应用帐号均有安全保护功能，请妥善保管您的用户名及密码信息。本应用将通过对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在“完善的安全措施”。<br />
      b) 在使用本应用网络服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是本应用用户名及密码发生泄露，请您立即联络本应用客服，以便本应用采取相应措施。
    </p>
    <h2 style="font-family:&quot;font-weight:500;color:#333333;font-size:30px;">
      用户协议
    </h2>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      "当您申请用户时，表示您已经同意遵守本规章。
    </p>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      欢迎您加入本站点参与交流和讨论，本站点为社区，为维护网上公共秩序和社会稳定，请您自觉遵守以下条款：
    </p>
    <p style="color:#333333;font-family:&quot;font-size:14px;">
      一、不得利用本站危害国家安全、泄露国家秘密，不得侵犯国家社会集体的和公民的合法权益，不得利用本站制作、复制和传播下列信息：<br />
      （一）煽动抗拒、破坏宪法和法律、行政法规实施的；<br />
      （二）煽动颠覆国家政权，推翻社会主义制度的；<br />
      （三）煽动分裂国家、破坏国家统一的；<br />
      （四）煽动民族仇恨、民族歧视，破坏民族团结的；<br />
      （五）捏造或者歪曲事实，散布谣言，扰乱社会秩序的；<br />
      （六）宣扬封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖、教唆犯罪的；&emsp;<br />
      （七）公然侮辱他人或者捏造事实诽谤他人的，或者进行其他恶意攻击的；<br />
      （八）损害国家机关信誉的；<br />
      （九）其他违反宪法和法律行政法规的；<br />
      （十）进行商业广告行为的。<br />
      二、互相尊重，对自己的言论和行为负责。<br />
      三、禁止在申请用户时使用相关本站的词汇，或是带有侮辱、毁谤、造谣类的或是有其含义的各种语言进行注册用户，否则我们会将其删除。<br />
      四、禁止以任何方式对本站进行各种破坏行为。<br />
      五、如果您有违反国家相关法律法规的行为，本站概不负责，您的登录信息均被记录无疑，必要时，我们会向相关的国家管理部门提供此类信息。"
    </p>
  </div>
</template>
<script>
export default {
  name: 'agreement',
  data() {
    return {

    }
  },
  mounted() {},
  methods: {

  }
}

</script>
<style>
</style>
